import OfferReports from './offer-reports';

export default OfferReports;